<template>
  <div class="loading" v-if="isLoading">
    <img src="../assets/loading.svg" alt="loading" />
  </div>
  <div v-else-if="organizations.length !== 0">
    <api-organization
      v-for="org in organizations"
      v-bind:org="org"
      v-bind:auth="auth"
      v-bind:key="org.id"
    >
    </api-organization>
  </div>
  <div v-else>
    <div>
      <api-organization-modal
        :auth="auth"
        :show="showModal"
        @close="showModal = false"
      ></api-organization-modal>
      <v-btn color="deep-orange" dark id="show-modal" @click="showModal = true"
        >New organization</v-btn
      >
    </div>
  </div>
</template>

<script>
import ApiOrganization from "./ApiOrganization";
import ApiOrganizationModal from "./ApiOrganizationModal";

const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

export default {
  name: "api-clients",
  components: { ApiOrganization, ApiOrganizationModal },
  props: ["auth"],
  data() {
    return {
      isLoading: true,
      organizations: [],
      showModal: false
    };
  },
  created: function() {
    const load = () => {
      this.$http.get(`${API_ENDPOINT}/organization`).then(
        response => {
          this.organizations = response.body.data;
          this.isLoading = false;
        },
        error => {
          console.error(`Error while retrieving object: ${error.statusText}`);
          this.isLoading = false;
        }
      );
    };

    this.$on("api-organization-update", () => {
      load();
    });

    load();
  }
};
</script>

<style>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 800px;
  background-color: white;
}

img {
  width: 100px;
  height: 100px;
}

.button-info {
  color: #fff !important;
  background-color: #2196f3 !important;
  border-color: #2196f3 !important;
}
</style>
